export const validarFechaNoFutura = (fecha) => {
  if (!fecha) return false;
  const fechaDate = new Date(fecha);
  const hoy = new Date();
  hoy.setHours(20, 0, 0);
  return fechaDate <= hoy && !isNaN(fechaDate.getTime());
};
